import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const MetaCtx = createContext(null);

export function MetaProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [users, setUsers] = useState([]);
  const [version, setVersion] = useState(0);
  const [addLeadOpen, setAddLeadOpen] = useState(false);
  const [taskOpen, setTaskOpen] = useState(false);

  const refresh = useCallback(async () => {
    const [s, u] = await Promise.all([api.get("/settings"), api.get("/users")]);
    setSettings(s.data);
    setUsers(u.data);
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const bump = () => setVersion((v) => v + 1);
  const stages = settings?.stages || [];
  const stageName = (k) => stages.find((s) => s.key === k)?.name || k;
  const activeUsers = users.filter((u) => u.active);

  return (
    <MetaCtx.Provider value={{ settings, setSettings, users, activeUsers, stages, stageName, refresh, version, bump,
      addLeadOpen, setAddLeadOpen, taskOpen, setTaskOpen }}>
      {children}
    </MetaCtx.Provider>
  );
}

export const useMeta = () => useContext(MetaCtx);
